<template>
  <div class="trading_operation">
    <div class="title_box">
      <div
        v-for="(item, index) of tradingTypes"
        :key="index"
        :class="{ activeTitle: currentTradingType === item.name }"
        class="each_title"
        @click="currentTradingType = item.name"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>

    <div class="operation_box">
      <TradingOperationItem
        side="BULL"
        :coinsAsset="coinsAsset"
        :contractList="contractList"
        :holdingData="holdingData"
        :currentTradingType="currentTradingType"
        @tradeSucceed="tradeSucceedEvent"
        @transferSucceed="transferSucceedEvent"
      />
      <div class="divider"></div>
      <TradingOperationItem
        side="BEAR"
        :coinsAsset="coinsAsset"
        :holdingData="holdingData"
        :contractList="contractList"
        :currentTradingType="currentTradingType"
        @tradeSucceed="tradeSucceedEvent"
        @transferSucceed="transferSucceedEvent"
      />
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import TradingOperationItem from './TradingOperationItem'
import { fetchHoldingData, fetchContractAndCurrency } from '@/api/contract'
import { ajax_getMyAssetList } from '@/api/assets'
import EventBus from '@/utils/event-bus'

export default {
  components: {
    TradingOperationItem,
  },
  data() {
    return {
      coinsAsset: [],
      holdingData: [],
      contractList: [],
      tradingTypes: [
        { title: this.$t('限价交易'), name: 'limit' },
        { title: this.$t('市价交易'), name: 'market' },
      ],
      currentTradingType: 'limit',
    }
  },
  computed: {
    ...mapGetters(['isSignIn']),
  },
  mounted() {
    if (this.isSignIn) {
      this.getHoldingData()
      this.getContractList()
      this.getCoinsAsset()
    }
    EventBus.$on('contractTradeSucceed', this.getHoldingData)
  },
  watch: {
    isSignIn: {
      async handler(newVal) {
        if (!newVal) {
          this.holdingData = []
          this.contractList = []
        }
      },
    },
  },
  methods: {
    transferSucceedEvent() {
      this.getHoldingData()
      this.getCoinsAsset()
    },
    tradeSucceedEvent() {
      this.getHoldingData()
    },
    async getContractList() {
      const { contractRes } = await fetchContractAndCurrency()
      this.contractList = contractRes
    },
    async getHoldingData() {
      this.holdingData = await fetchHoldingData({ holdStatus: 'HOLDING' })
    },
    async getCoinsAsset() {
      const { item } = await ajax_getMyAssetList({
        start: 0,
        offset: 9999,
      })
      this.coinsAsset = item
    },
  },
}
</script>
<style lang="less" scoped>
.trading_operation {
  min-width: 668px;

  .title_box {
    padding: 12px 20px 0 20px;
    .each_title {
      margin-right: 20px;
      display: inline-block;
      cursor: pointer;
      span {
        font-size: 16px;
        font-family: PingFangSC-Medium, 'PingFang SC';
        font-weight: 500;
        color: @textColor5;
        line-height: 22px;
      }
      p {
        margin-top: 5px;
        height: 2px;
      }
    }
    // 动态控制活跃交易类型样式
    .activeTitle {
      span {
        color: @textColor4;
      }
      p {
        background-color: rgba(66, 179, 250, 1);
      }
    }
  }
  .operation_box {
    display: flex;
    padding: 0 20px;
    .divider {
      width: 1px;
      background-color: #252a44;
      margin: 0 15px;
    }
  }
}
</style>
